<div class="container-fluid">
    <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12 cadastro">Cadastro</div>
    </div>
    <div class="form-box container-fluid">
        <div class="row">
            <div class="col-12 form-title pt-4">VINCULAR QRCODES EM LOTE</div>
            <div class="col-12 form-subtitle pb-4">Dados</div>
            <form class="col-12" [formGroup]="cadastroFormGroup" #cadastroForm="ngForm" (ngSubmit)="onSubmit(cadastroFormGroup.value)">
                <div class="py-2 container-fluid">

                    <div class="">
                        <table class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">CPF</th>
                                    <th scope="col">Nome</th>
                                    <th scope="col">Sobrenome</th>
                                    <th scope="col" style="min-width: 200px;">Unidade</th>
                                    <th scope="col">Data de nascimento</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let colaborador of colaboradorControls; index as i">
                                    <ng-container [formGroup]="colaborador">
                                        <!--linhaLote-->
                                        <th scope="row">{{i+1}}</th>
                                        <!--CPF-->
                                        <td>
                                            <div class="custom-input-container">
                                                <input [textMask]="{
                                            mask: MASKS.cpf.textMask
                                        }" formControlName="documento" id="documento" class="custom-input-outline m-0" type="text" (blur)="colaboradorControls[i].controls.documento.setValue(CompleteWithZero(colaboradorControls[i].controls.documento.value))"
                                        autocomplete="off"/>

                                            </div>
                                            <div *ngIf="
                                        colaboradorControls[i].controls.documento.invalid &&
                                        (colaboradorControls[i].controls.documento.dirty ||
                                        colaboradorControls[i].controls.documento.touched)
                                    " class="text-danger">
                                                <div *ngIf="colaboradorControls[i].controls.documento.errors.required">
                                                    CPF é obrigatório!
                                                </div>
                                                <div *ngIf="colaboradorControls[i].controls.documento.errors.cpf">
                                                    CPF inválido.
                                                </div>
                                            </div>
                                        </td>
                                        <!--Nome-->
                                        <td>
                                            <div class="custom-input-container">
                                                <input formControlName="nome" id="nome" class="custom-input-outline m-0" type="text" autocomplete="off"/>
                                            </div>
                                            <div *ngIf="
                                            colaboradorControls[i].controls.nome.invalid &&
                                                    (colaboradorControls[i].controls.nome.dirty || colaboradorControls[i].controls.nome.touched)
                                                " class="text-danger">
                                                <div *ngIf="colaboradorControls[i].controls.nome.errors.required">
                                                    Nome é obrigatório!
                                                </div>
                                                <div *ngIf="colaboradorControls[i].controls.nome.errors.maxlength">
                                                    Nome deve conter no máximo 100 caracteres.
                                                </div>
                                                <div *ngIf="colaboradorControls[i].controls.nome.errors.minlength">
                                                    Nome deve conter no mínimo 3 caracteres.
                                                </div>
                                            </div>
                                        </td>
                                        <!--Sobrenome-->
                                        <td>
                                            <div class="custom-input-container">
                                                <input formControlName="sobrenome" id="sobrenome" class="custom-input-outline m-0" type="text" autocomplete="off"/>
                                            </div>
                                            <div *ngIf="
                                            colaboradorControls[i].controls.sobrenome.invalid &&
                                                    (colaboradorControls[i].controls.sobrenome.dirty ||
                                                    colaboradorControls[i].controls.sobrenome.touched)
                                                " class="text-danger">
                                                <div *ngIf="colaboradorControls[i].controls.sobrenome.errors.required">
                                                    Sobrenome é obrigatório!
                                                </div>
                                                <div *ngIf="colaboradorControls[i].controls.sobrenome.errors.maxlength">
                                                    Sobrenome deve conter no máximo 100 caracteres.
                                                </div>
                                                <div *ngIf="colaboradorControls[i].controls.sobrenome.errors.minlength">
                                                    Sobrenome deve conter no mínimo 3 caracteres.
                                                </div>
                                            </div>
                                        </td>
                                        <!--Unidade-->
                                        <td>
                                            <div class="div-select-create">
                                                <div class="custom-input-container">
                                                    <select formControlName="unidadeId" id="unidadeId" class="custom-input-outline m-0">
                                                        <option disabled value="">Selecione...</option>
                                                        <option *ngFor="
                                                                let itemUnidade of unidadesList
                                                            " value="{{ itemUnidade.unidadeId }}">
                                                            {{ itemUnidade.nome }}
                                                        </option>
                                                        <option value="">Nenhum</option>
                                                    </select>
                                                </div>
                                                <div *ngIf="
                                                colaboradorControls[i].controls.unidadeId.dirty ||
                                                colaboradorControls[i].controls.unidadeId.touched
                                                    " class="text-danger">
                                                    <div *ngIf="
                                                    colaboradorControls[i].controls?.unidadeId?.errors?.required
                                                        ">
                                                        Unidade é obrigatória!
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <!--Data de nascimento-->
                                        <td>
                                            <div class="input-container w-90">
                                                <div class="input-group">
                                                    <input formControlName="dataNascimento" [options]="
                                                            myDatePickerOptions
                                                        " angular-mydatepicker #dp="angular-mydatepicker" class="form-control m-0 input-data" name="dataNascimento" (keyup)="dateMask($event)" [maxlength]="10" autocomplete="off"/>
                                                    <button type="button" class="btn input-group-append input-group-text p-0 calendar-btn" (click)="
                                                            dp.toggleCalendar()
                                                        "></button>
                                                </div>
                                            </div>
                                            <div *ngIf="
                                            colaboradorControls[i].controls.dataNascimento.invalid &&
                                                    (colaboradorControls[i].controls.dataNascimento.dirty ||
                                                    colaboradorControls[i].controls.dataNascimento.touched)
                                                " class="text-danger">
                                                <div *ngIf="
                                                colaboradorControls[i].controls.dataNascimento.errors
                                                            .required
                                                    ">
                                                    Data de nascimento é obrigatória
                                                </div>
                                                <div *ngIf="
                                                colaboradorControls[i].controls.dataNascimento.errors
                                                            .minimumAge
                                                    ">
                                                    O favorecido deve ter idade superior a {{minimumAge}} anos
                                                </div>
                                                <div *ngIf="
                                                colaboradorControls[i].controls.dataNascimento.errors
                                                            .lockDate
                                                    ">
                                                    Data de nascimento inválida
                                                </div>
                                            </div>
                                        </td>
                                        <td><button type="button" class="btn btn-danger" (click)="removeColaborador(i)">Remover</button></td>
                                    </ng-container>
                                </tr>
                            </tbody>
                        </table>

                        <div><button type="button" class="btn btn-primary" (click)="addColaborador()">Adicionar</button>
                        </div>
                    </div>
                    <div class="row button-container mt-5 mb-3" [ngClass]="{ 'btn-fixed': isMobile }">
                        <div class="col-12 text-right">
                            <button type="submit" class="custom-button-full">
                                Salvar
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>